import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, PhoneCall } from "@phosphor-icons/react";
import { COMPANY, STATS } from "@/lib/siteData";

export const HeroIntro = () => {
  return (
    <section
      id="intro"
      data-testid="hero-intro"
      className="relative bg-[#1a1a1a] grain"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 md:gap-16 relative z-10">
          {/* Left label */}
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-[2px] bg-[#c41e3a]" />
              <span className="font-mono-upper text-[11px] text-[#c41e3a]">
                Welcome to D. Welch
              </span>
            </div>
            <h2 className="font-display font-black text-white text-4xl md:text-5xl leading-[1] tracking-[-0.02em]">
              Prairie-tough roofing,
              <span className="block text-[#c41e3a]">engineered to last.</span>
            </h2>
          </div>

          {/* Right content */}
          <div className="lg:col-span-8">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.7 }}
              className="font-body text-white/75 text-lg md:text-xl leading-relaxed max-w-[720px]"
            >
              {COMPANY.name} is Saskatoon&apos;s trusted specialist in
              sprayed urethane foam roofing, elastomeric waterproof coatings,
              and closed-cell foam insulation. We serve commercial, residential,
              and heavy-industrial clients across Saskatchewan — delivering
              seamless, energy-efficient roof systems that stand up to
              &minus;40° winters and +35° summers, year after year.
            </motion.p>

            <div className="flex flex-wrap gap-3 mt-9">
              <a
                href="#contact"
                data-testid="intro-cta-quote"
                className="group inline-flex items-center gap-3 bg-[#c41e3a] hover:bg-[#e62244] text-white font-bold tracking-[0.22em] uppercase text-[11px] px-6 py-4 transition-colors"
              >
                Book a Site Assessment
                <ArrowRight
                  size={16}
                  weight="bold"
                  className="transition-transform group-hover:translate-x-1"
                />
              </a>
              <a
                href={`tel:${COMPANY.phoneRaw}`}
                data-testid="intro-cta-call"
                className="inline-flex items-center gap-3 border border-white/20 hover:border-[#c41e3a] text-white font-bold tracking-[0.22em] uppercase text-[11px] px-6 py-4 transition-colors"
              >
                <PhoneCall size={14} weight="bold" className="text-[#c41e3a]" />
                {COMPANY.phone}
              </a>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-0 mt-14 border-t border-white/10">
              {STATS.map((s, idx) => (
                <div
                  key={s.label}
                  data-testid={`stat-${idx}`}
                  className={`py-7 ${
                    idx !== 0 ? "md:border-l" : ""
                  } ${idx === 2 ? "border-l md:border-l" : ""} ${
                    idx % 2 !== 0 ? "border-l" : ""
                  } border-white/10 md:pl-6`}
                >
                  <div className="font-display font-black text-3xl md:text-4xl text-white tracking-tight">
                    {s.value}
                  </div>
                  <div className="mt-2 font-mono-upper text-[10px] text-white/55">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="section-divider" />
    </section>
  );
};

export default HeroIntro;
